import { createI18n } from "vue-i18n";
import zhCN from "./locales/zh-CN";
import enUS from "./locales/en-US";

const messages = {
  "zh-CN": zhCN,
  "en-US": enUS,
};

// Get browser language, defaults to Chinese
const getDefaultLocale = () => {
  try {
    // Check if we're in a browser environment
    if (typeof window === "undefined") {
      return "zh-CN";
    }

    // First, check domain name - highest priority
    const hostname = window.location.hostname;
    if (hostname.includes(".cn")) {
      // Chinese domain
      return "zh-CN";
    }

    // Try to get saved language from localStorage
    const savedLocale = localStorage.getItem("locale");
    if (savedLocale && (savedLocale === "zh-CN" || savedLocale === "en-US")) {
      return savedLocale;
    }

    // Try to determine from browser language
    if (typeof navigator !== "undefined" && navigator.language) {
      const browserLang = navigator.language || (navigator as any).userLanguage;
      if (browserLang.startsWith("zh")) {
        return "zh-CN";
      }
      return "en-US";
    }
  } catch (error) {
    // If any error occurs (e.g., localStorage is disabled), use default language
    console.warn("Failed to get locale from localStorage or navigator:", error);
  }

  // Default to English for non-.cn domains
  return "en-US";
};

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getDefaultLocale(),
  fallbackLocale: "zh-CN",
  messages,
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
});

export default i18n;
